
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/x",
      function () {
        return require("private-next-pages/destinations/x.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/x"])
      });
    }
  